import { Stack } from "@mui/material";
import TextField from '@mui/material/TextField';
import { useState } from "react";
import Button from "@mui/material/Button";
import {Box} from "@mui/material";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword  } from "firebase/auth";
import { doc, addDoc, collection } from "firebase/firestore"; 
import { db, auth } from "../firebase-config";
import { useNavigate } from "react-router-dom";


const Login = () => {

    const navigate = useNavigate ();
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [alertMessage, setAlertMessage] = useState("");
    
  
    // const auth = getAuth();
    const handleLogin = () => {
        const login_ = login.replace(/\s/g, '');
        signInWithEmailAndPassword(auth, login_, password)
          .then((userCredential) => {
            const user = userCredential.user;
            // console.log("Singed in user: ", user);
            localStorage.setItem("user", "logged");
            navigate('/adminhome');
          })
          .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log("An error occured: ", error);
      });
    };

    return(
        <Stack height="100vh" direction="column" justifyContent="flex-end" spacing={3} sx={{height:'100%', alignItems: 'center', justifyContent: 'center'}}>
            <Box sx={{height: '100px'}}></Box>
            <TextField
                label="Email"
                id="outlined-size-small1"
                size="small"
                variant="outlined"
                className="form-input"
                value={login}
                style={{ margin: 16 }}
                onChange={e => setLogin(e.target.value)}
            />
            <TextField
                label="Heslo"
                id="outlined-size-small2"
                size="small"
                variant="outlined"
                className="form-input"
                type="password"
                value={password}
                style={{ margin: 16 }}
                onChange={e => setPassword(e.target.value)}
            />
            <Button
                variant="contained"
                color="primary"
                className="form-input"
                size="large"
                style={{ margin: 16 }}
                onClick={handleLogin}
            >
                Prihlásiť
            </Button>
        
        </Stack>
    )
}

export default Login;